import { observer } from 'mobx-react-lite';
import { PlayIcon } from 'lucide-react';
import Frame from '../uikit/Frame';
import Box from '../uikit/Box';

const BUTTON_ROWS = [
    { label: 'btn', buttons: [{ className: 'btn' }, { className: 'btn', disabled: true }] },
    {
        label: 'btn-primary',
        buttons: [
            { className: 'btn btn-primary' },
            { className: 'btn btn-primary', disabled: true },
        ],
    },
    {
        label: 'btn-soft',
        buttons: [{ className: 'btn btn-soft' }, { className: 'btn btn-soft', disabled: true }],
    },
    {
        label: 'btn-outline',
        buttons: [
            { className: 'btn btn-outline' },
            { className: 'btn btn-outline', disabled: true },
        ],
    },
    {
        label: 'btn-soft btn-primary',
        buttons: [
            { className: 'btn btn-soft btn-primary' },
            { className: 'btn btn-soft btn-primary', disabled: true },
        ],
    },
    {
        label: 'btn-ghost',
        buttons: [{ className: 'btn btn-ghost' }, { className: 'btn btn-ghost', disabled: true }],
    },
    {
        label: 'btn-circle',
        buttons: [
            { className: 'btn btn-circle', icon: true },
            { className: 'btn btn-circle btn-primary', icon: true },
            { className: 'btn btn-circle btn-soft', icon: true },
            { className: 'btn btn-circle btn-ghost', icon: true },
        ],
    },
    {
        label: 'btn-action-primary',
        buttons: [
            { className: 'btn btn-action-primary' },
            { className: 'btn btn-action-primary', disabled: true },
        ],
    },
    {
        label: 'btn-action-neutral',
        buttons: [
            { className: 'btn btn-action-neutral' },
            { className: 'btn btn-action-neutral', disabled: true },
        ],
    },
    {
        label: 'btn-action-outline',
        buttons: [
            { className: 'btn btn-action-outline' },
            { className: 'btn btn-action-outline', disabled: true },
        ],
    },
    {
        label: 'btn-action-soft',
        buttons: [
            { className: 'btn btn-action-soft' },
            { className: 'btn btn-action-soft', disabled: true },
        ],
    },
];

const ButtonPanel = observer(({ theme }: { theme: 'light' | 'dark' }) => {
    return (
        <div data-theme={theme} className="bg-base-100 flex-1 rounded-lg p-4">
            <h3 className="text-base-content mb-4 text-sm font-semibold capitalize">{theme}</h3>
            <div className="flex flex-col gap-3">
                {BUTTON_ROWS.map((row) => (
                    <div key={row.label} className="flex items-center gap-3">
                        <span className="text-base-content/50 w-40 shrink-0 text-xs">
                            {row.label}
                        </span>
                        <div className="flex flex-wrap items-center gap-2">
                            {row.buttons.map(
                                (
                                    btn: { className: string; disabled?: boolean; icon?: boolean },
                                    idx,
                                ) => (
                                    <button
                                        key={idx}
                                        className={btn.className}
                                        disabled={btn.disabled}
                                    >
                                        {btn.icon ? (
                                            <PlayIcon className="size-4" />
                                        ) : btn.disabled ? (
                                            'Disabled'
                                        ) : (
                                            'Button'
                                        )}
                                    </button>
                                ),
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
});

/**
 * 개발 환경에서 UI 컴포넌트를 확인할 수 있는 페이지
 */
const UiPage = observer(() => {
    return (
        <Frame>
            <Frame.Title title="UI Guide" />
            <Box>
                <Box.Title title="Buttons" />
                <div className="flex flex-row gap-4">
                    <ButtonPanel theme="light" />
                    <ButtonPanel theme="dark" />
                </div>
            </Box>
        </Frame>
    );
});

export default UiPage;
